import React, { useEffect, useState } from "react"
import { Route, Switch, Redirect, withRouter } from "react-router-dom"
import { connect } from "react-redux"
import { bindActionCreators } from 'redux'
import { ROUTES } from './shared/constants/routes.constants'
import * as CONTAINERS from './containers'
import 'react-toastify/dist/ReactToastify.css'
import { getAuthToken } from './services/localstorage/localStorage.service'
import { fetchMyDetails } from "./actions/auth.action"
import { getHmdDevicesWithoutLoading } from "./actions/hmdDevices.action"
import { homePageUrl } from "./shared/utils/util"

const AppRouter = (props) => {
  let [authToken] = useState(getAuthToken())

  props.getHmdDevicesWithoutLoading();

  useEffect(() => {
    if (authToken && !props.loggedInUser) {
      props.fetchMyDetails()
    }
  }, [])

  return (
    <React.Fragment>
      {
        props.loggedInUser ? (
          <Switch>
            <Route exact path={ROUTES.HOME} component={ CONTAINERS.HomeContainer } loggedInUser = { props.loggedInUser } />
            <Redirect to = { homePageUrl(props.loggedInUser) } />
          </Switch>
        ) : (
          <Switch>
            <Route exact path={ ROUTES.LOGIN } component = { CONTAINERS.LoginContainer } />
            { !authToken && (
              <Route exact path="/" >
                <Redirect to = { ROUTES.LOGIN } />
              </Route>
            )}
            { !authToken && <Redirect to = { ROUTES.LOGIN } /> }                
          </Switch>
        )
      }
    </React.Fragment>
  )

}

const mapStateToProps = ({ auth }) => ({
  loggedInUser: auth.loggedInUser
})

const mapDispatchToProps = dispatch => (
  bindActionCreators({ 
    fetchMyDetails,
    getHmdDevicesWithoutLoading
  }, dispatch)
)

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AppRouter))
